import { Injectable } from '@angular/core';
import { AuthServerProvider } from './auth.service';
import { CrewEventManager } from '../event-manager.service';
import { ServiceConfig } from '../../core/core.constants';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { tap } from 'rxjs/operators';

@Injectable()
export class Principal {
    private userIdentity: Nema.Crew.Model.ApplicationUser;

    constructor(
        private eventManager: CrewEventManager,
        private authServerProvider: AuthServerProvider) {
    }

    clearUserIdentity() {
        this.userIdentity = undefined;
    }

    identity(force: boolean = false): Observable<Nema.Crew.Model.ApplicationUser> {
        if (force) {
            this.userIdentity = undefined;
        }

        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return of(this.userIdentity);
        }

        // Automatically log the user in
        return this.authServerProvider.getAccount().pipe(
            tap(
                userIdentity => {
                    if (userIdentity) {
                        this.userIdentity = userIdentity;

                        ServiceConfig.loggedInUser = this.userIdentity.Name;

                        this.eventManager.authenticationSuccess(this.userIdentity);
                    } else {
                        this.userIdentity = undefined;
                    }
                },
                () => this.userIdentity = undefined));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/auth/principal.service.ts